import { PopupContainer } from './LocationPopup.styles';

const LocationPopup = ({ locationList, onDelete, onOpenMap, onClose }) => {
    return (
        <PopupContainer>
            <div>
                <div className='header'>
                    위치 목록
                    <div className='closeBtn' onClick={onClose}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <line x1="6" y1="6" x2="18" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                            <line x1="18" y1="6" x2="6" y2="18" stroke="#495057" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                </div>
                <div className='body'>
                    {locationList && locationList.map((item, i) => (
                        <div className='locationItem' key={item.label + i}>
                            <span>{item.label}</span>
                            {item.type !== "curr" &&
                                <button className='delBtn' onClick={() => onDelete(i)}>×</button>
                            }
                        </div>
                    ))}
                    <button className='addBtn' onClick={onOpenMap}>위치 추가</button>
                </div>
            </div>
        </PopupContainer>
    );
};

export default LocationPopup;
